// extracted by mini-css-extract-plugin
export default {"source":"ExternalAnnotations_source__1GSy-"};